import { render, staticRenderFns } from "./Programs.vue?vue&type=template&id=1b561c5d&scoped=true&"
import script from "./Programs.vue?vue&type=script&lang=js&"
export * from "./Programs.vue?vue&type=script&lang=js&"
import style0 from "./Programs.vue?vue&type=style&index=0&lang=css&"
import style1 from "./Programs.vue?vue&type=style&index=1&id=1b561c5d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b561c5d",
  null
  
)

export default component.exports